import { useEffect } from "react";
import { useContent, useSettings } from "@/lib/hooks";

export function useSeo(title, description) {
  useEffect(() => {
    if (title) document.title = `${title} — Water Business Guru`;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement("meta"); m.setAttribute("name", "description"); document.head.appendChild(m); }
      m.setAttribute("content", description);
    }
    let c = document.querySelector('link[rel="canonical"]');
    if (!c) { c = document.createElement("link"); c.setAttribute("rel", "canonical"); document.head.appendChild(c); }
    c.setAttribute("href", window.location.href.split("?")[0]);
    return () => { document.title = "Water Business Guru"; };
  }, [title, description]);
}

export default function PolicyPage({ contentKey, fallbackTitle, eyebrow = "Legal" }) {
  const { data, isLoading } = useContent(contentKey);
  const title = data?.title || fallbackTitle;
  const sections = data?.sections || [];
  const desc = sections[0]?.body?.slice(0, 155) || `${fallbackTitle} — Water Business Guru.`;
  useSeo(title, desc);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14" data-testid={`policy-${contentKey}`}>
      <span className="eyebrow">{eyebrow}</span>
      <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold text-navy">{title}</h1>
      {data?.last_updated && <p className="mt-2 text-sm text-slate-400" data-testid="policy-updated">Last updated: {data.last_updated}</p>}
      {isLoading ? (
        <div className="mt-8 space-y-3">{[1, 2, 3].map((i) => <div key={i} className="h-20 bg-white border border-slate-200 rounded-lg animate-pulse" />)}</div>
      ) : sections.length ? (
        <div className="mt-8 space-y-6">
          {sections.map((s, i) => (
            <section key={i}>
              {s.heading && <h2 className="text-lg font-bold text-navy mb-1.5">{s.heading}</h2>}
              <p className="text-slate-600 leading-relaxed whitespace-pre-line text-sm sm:text-base">{s.body}</p>
            </section>
          ))}
        </div>
      ) : (
        <p className="mt-8 text-slate-600 leading-relaxed whitespace-pre-line">{data?.body}</p>
      )}
    </div>
  );
}
